// extracted by mini-css-extract-plugin
export default {"component":"NoContent__component--ig-pTpzD","picture":"NoContent__picture--ig-VnyuE","icon":"NoContent__icon--ig-WgKzo","description":"NoContent__description--ig-AU4yt"};